import React from 'react';
import * as S from './FixedRatesTableColumn.styled';
export const FixedRatesTableColumn = ({ title, subtitle, inputs }) => {
    return (React.createElement(S.Container, null,
        React.createElement(S.Title, null, title),
        React.createElement(S.Subtitle, null, subtitle),
        inputs.map((input, index) => (React.createElement(S.Input, { key: index }, input)))));
};
